module.exports = __webpack_public_path__ + "./docs/img/big-icon-typedef.774fda2ecf10dce13dd60d4b7d17a845.svg";